export default __webpack_public_path__ + "static/layout_cloud_topRight-835fc024c9d3392976603aa9ffad00f2.webp";